import React from "react";

import { IgButton } from "@intelligems/ig-theme/IgButton";
import { Dialog } from "@mui/material";
import { ProductPicker } from "@src/components/MainApp/SharedProductPicker/ProductPicker";
import { useDispatch, useSelector } from "@src/store";
import { closeProductPicker } from "@src/store/slices/productPicker";
import { isProductPickerOpen } from "@src/store/slices/productPicker/selectors/isProductPickerOpen";
import { saveCustomEventsProductPicker } from "@src/store/slices/productPicker/thunks/customEvents/saveCustomEventsProductPicker";

export const CustomEventProductPickerWrapper = () => {
  const productPickerOpen = useSelector(isProductPickerOpen("customEvents"));
  const dispatch = useDispatch();

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth={"lg"}
      open={productPickerOpen}
      sx={{ zIndex: 1401 }}
      onClose={() => dispatch(closeProductPicker())}
      slotProps={{
        paper: {
          style: { borderRadius: 15 },
        },
      }}
    >
      <ProductPicker
        dialogActions={[
          <IgButton
            key={`button-2`}
            variant={"text"}
            onClick={() => dispatch(closeProductPicker())}
          >
            Cancel
          </IgButton>,
          <IgButton
            key={`button-1`}
            variant={"contained"}
            onClick={() => void dispatch(saveCustomEventsProductPicker())}
          >
            Save Products
          </IgButton>,
        ]}
      />
    </Dialog>
  );
};
